// tslint:disable
import * as angular from 'angular';
import {CommonModule} from './area-module';
import './styles/modules.scss';

angular.module('app.areas.common.svgCache', []);

angular.module('app.areas.common', ['app.areas.common.svgCache', CommonModule.name])
